import React from 'react';

const TimelineItem = ({ weeks, title, description }) => {
  return (
    <div className="flex gap-4">
      {/* Timeline indicator */}
      <div className="flex flex-col items-center">
        <div 
          className="w-3 h-3 rounded-full flex-shrink-0"
          style={{ background: 'linear-gradient(135deg, #7874F8 0%, #09C9E9 100%)' }}
        ></div>
        <div 
          className="w-0.5 flex-1 min-h-[60px]"
          style={{ background: 'linear-gradient(180deg, #7874F8 0%, #09C9E9 100%)' }}
        ></div>
      </div>
      
      {/* Content */}
      <div className="pb-6">
        <span className="afu-badge mb-2 inline-block">{weeks}</span>
        <p className="text-sm leading-relaxed" style={{ color: '#333' }}>{description}</p>
      </div>
    </div>
  );
};

const Step10 = ({ data, onSelect, overrides }) => {
  const timeline = [
    {
      weeks: '2 WEEKS',
      description: 'Support energy levels and daily vitality.'
    },
    {
      weeks: '4–6 WEEKS',
      description: 'Support metabolism and temperature regulation.'
    },
    {
      weeks: '8–12 WEEKS',
      description: 'Support hair, skin, and overall thyroid balance.'
    }
  ];

  return (
    <div className="flex flex-col">
      {/* Heading */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-3" style={{ color: '#1a1a2e' }}>
        <span className="gradient-text">Hashi-aid</span> starts supporting your body in as little as 1–2 weeks.*
      </h1>
      
      {/* Supporting statement */}
      <p className="text-base mb-8 leading-relaxed" style={{ color: '#666' }}>
        Users often report improved energy and mental clarity within the first few weeks.*
      </p>

      {/* Timeline Card */}
      <div className="product-card p-6 mb-6">
        <div className="flex flex-col">
          {timeline.map((item, index) => (
            <TimelineItem
              key={index}
              weeks={item.weeks}
              description={item.description}
            />
          ))}
          {/* Final dot without line */}
          <div className="flex gap-4">
            <div className="flex flex-col items-center">
              <div 
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ background: 'linear-gradient(135deg, #09C9E9 0%, #43B9B2 100%)' }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="text-xs leading-relaxed" style={{ color: '#999' }}>
        *In individuals experiencing symptoms associated with thyroid imbalance.
      </p>
    </div>
  );
};

export default Step10;
